const config = {
    DELEGATE : 1,
    NODE_ONLY : 2,
    COMING_SOON : 3
};

if (typeof window.CONFIG === 'undefined') {
    window.CONFIG = config;
}